
<template>
  <div>
    <dialog-create-company></dialog-create-company>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateCompany from '../../../components/admin/company/DialogCreateCompany.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'NewCompanyPage',
  //mixins: [ validations ],
  components: {
    DialogCreateCompany
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>